const FilterContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className="w-full px-4 lg:gap-2 lg:px-6"
      style={{
        borderBottom: "0.5px solid lch(86.22 0 282.863)",
        minHeight: "45px",
        overflowX: "overlay" as React.CSSProperties["overflowX"],
        scrollbarWidth: "none",
        paddingTop: "7.5px",
        paddingBottom: "7.5px",
      }}
    >
      {children}
    </div>
  );
};

export { FilterContainer };